jQuery(document).ready(function ($) {
    const inputs = $('.ninja-forms-field:not(.select2-hidden-accessible)');

    $(document).on('nfFormReady', function () {
        // activeListRadio();
        initializeSelect2();
        checkFields();
    });

    function initializeSelect2() {
        $('.enable-select2 select').each(function () {
            const selectName = $(this).attr('name');
            if (selectName === 'salutation' || selectName === 'dsalutation') {
                $(this).select2({
                    placeholder: "Anrede",
                    minimumResultsForSearch: -1,
                    dropdownParent: $(this).parent()
                });
            } else {
                $(this).select2({
                    minimumResultsForSearch: -1,
                    dropdownParent: $(this).parent()
                });
            }
        });
    }

    $(document).on('focus', '.ninja-forms-field', function () {
        let $input = $(this);
        let $container = $input.closest('.nf-field-container');

        $container.addClass('label-focus');
        $container.removeClass('potentially-required-label');
    });

    $(document).on('blur', '.ninja-forms-field', function () {
        let $input = $(this);
        let $attr = $input.attr('required');
        let $container = $input.closest('.nf-field-container');

        $container.removeClass('potentially-required-label');
        $container.removeClass('label-focus');
        if ($input.val().trim() === '') {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        } else {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        }
    });

    function checkFields() {

        $('.ninja-forms-field:not(.select2-hidden-accessible)').each(function () {
            let $input = $(this);
            let $attr = $(this).attr('required');
            let $container = $input.closest('.nf-field-container');

            $container.addClass('active-label');
            if (!$input.is('select') && !$input.is('input[type=checkbox]') && !$input.is('input[type=radio]')) {
                if ($input.val().trim() !== '') {
                    $container.addClass('label-up');
                } else {
                    $container.removeClass('label-up');
                }
            }
            if (typeof $attr !== 'undefined' && $attr !== false && ((!$.isArray($input.val()) && $input.val().trim() === '') || ($.isArray($input.val()) && $input.val().length > 0))) {
                $container.addClass('potentially-required-label');
            }

            if(($input.is('[type="text"]') || $input.is('[type="number"]') || $input.is('[type="tel"]') || $input.is('[type="date"]')) && !$attr && $input.val().trim() !== '') {
                $container.addClass('fake-nf-pass');
            }
        });
    }

    $(document).on('keyup blur change', '.ninja-forms-field:not(.select2-hidden-accessible)', function () {
        let $input = $(this);
        let $attr =  $input.attr('required');
        let $container = $input.closest('.nf-field-container');
        let $wrap = $input.closest('.field-wrap');


        if(($input.is('[type="text"]') || $input.is('[type="number"]') || $input.is('[type="tel"]') || $input.is('[type="date"]')) && !$attr) {
            if($input.val().trim() !== '') {
                $container.addClass('fake-nf-pass');
            } else {
                $container.removeClass('fake-nf-pass');
                $wrap.removeClass('nf-pass');
            }
        }
    });

    $(document).on('change', '.listselect-container select', function () {
        let $select = $(this);
        let $container = $select.closest('.listselect-container').length ? $select.closest('.listselect-container'): $select.closest('.textbox_with_tooltip-container');
        let valueSelect = $select.val();

        if(($.isArray(valueSelect) && valueSelect.length > 0) || (!$.isArray(valueSelect) && $select.val() !== '')) {
            $container.addClass('fake-nf-pass');
        } else {
            $container.removeClass('fake-nf-pass');
        }
    });

    $(document).on('input', '.ninja-forms-field', function () {
        let $input = $(this);
        let $attr = $input.attr('required');
        let $container = $input.closest('.nf-field-container');
        let value = $input.val();

        if ($input.is('select[multiple]')) {
            value = Array.isArray(value) && value.length > 0 ? value.join('').trim() : '';
        } else if ($input.is('select')) {
            value = value ? value.trim() : '';
        } else if (typeof value === 'string') {
            value = value.trim();
        } else {
            value = '';
        }

        $container.removeClass('potentially-required-label');
        if (value !== '') {
            $container.addClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        } else {
            $container.removeClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        }
    });

    $(document).on('change', '.change-structure input', function () {
        initializeSelect2();
        checkFields();
    });
});
